import { render, staticRenderFns } from "./TableServicesDetail.vue?vue&type=template&id=fbfa02b6"
import script from "./TableServicesDetail.vue?vue&type=script&lang=js"
export * from "./TableServicesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports